<template>
  <!-- 折线图图表 -->
  <div id="linecharts" ref="linecharts">
    
  </div>
</template>

<script>
export default {
  data(){
    return {
      yName: []
    }
  },
  props: ['echartdata'],
  mounted(){
    this.yName.push(this.echartdata.linedata.yName)
    this.drawChart()
  },
  methods:{
    drawChart(){
      let lineChart = this.$echarts.init(this.$refs.linecharts);
      let option = {
          grid: {
              top: '8%',
              left: '5%',
              right: '8%',
              bottom: '5%',
              containLabel: true
          },
          xAxis: {
              type: 'category',
              data: this.echartdata.linedata.xData,
          },
          yAxis: {
              type: 'value'
          },
          legend: {
              data: this.yName
          },
          series: [{
              name: this.echartdata.linedata.yName,
              data: this.echartdata.linedata.yData,
              type: 'line',
              smooth: true
          }]
      };
      // 绘制图表
      lineChart.setOption(option);
    }
  }

}
</script>

<style  lang="stylus" scoped>
#linecharts{
  height:500px;
  background-image:url('../assets/images/data/waterbg.png')
}
</style>